export class WidgetIdNamedQueryId {
    constructor(
        public readonly widgetId?: number,
        public readonly namedQueryId?: string,
    ) {}

    toRecord(): Record<string, unknown> {
        return {
            widgetId: this.widgetId,
            namedQueryId: this.namedQueryId,
        };
    }
}
